window.theme = window.theme || {};

/**
 * Re-render the product section with option_values (Shopify high-variant pattern).
 * Replaces .shopify-section markup, re-runs inline scripts, and dispatches section unload/load.
 */
theme.refreshProductSection = async function refreshProductSection(opts) {
  var sectionId = opts.sectionId;
  var optionValueIds = opts.optionValueIds || [];
  var productPath = opts.productPath || window.location.pathname;

  if (!sectionId) return;

  var base;
  try {
    base = new URL(productPath, window.location.origin);
  } catch (e) {
    base = new URL(window.location.pathname, window.location.origin);
  }

  var reqUrl = new URL(base.pathname, window.location.origin);
  reqUrl.searchParams.set('section_id', sectionId);
  if (optionValueIds.length) {
    reqUrl.searchParams.set('option_values', optionValueIds.join(','));
  }

  var res = await fetch(reqUrl.toString());
  if (!res.ok) return;
  var html = await res.text();

  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var newRoot = doc.querySelector('.shopify-section');
  if (!newRoot) {
    newRoot = doc.body.firstElementChild;
  }
  if (!newRoot) return;

  var currentContainer = document.querySelector(
    '[data-section-type="product"][data-section-id="' + sectionId.replace(/"/g, '\\"') + '"]'
  );
  if (!currentContainer) return;

  var oldSection = currentContainer.closest('.shopify-section');
  if (!oldSection) return;

  document.documentElement.dispatchEvent(
    new CustomEvent('shopify:section:unload', {
      bubbles: true,
      cancelable: true,
      detail: { sectionId: sectionId },
    })
  );

  oldSection.replaceWith(newRoot);

  newRoot.querySelectorAll('script').forEach(function (oldScript) {
    var t = oldScript.getAttribute('type');
    if (t === 'application/json' || t === 'application/ld+json') return;
    if (oldScript.src) return;
    var newScript = document.createElement('script');
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });

  document.documentElement.dispatchEvent(
    new CustomEvent('shopify:section:load', {
      bubbles: true,
      cancelable: true,
      detail: { sectionId: sectionId },
    })
  );

  if (typeof window.selectHandleChange === 'function') {
    window.selectHandleChange();
  }

  theme.syncVariantUrlFromSection(sectionId);

  if (typeof window.bindCartAddFormsForCartDrawer === 'function') {
    window.bindCartAddFormsForCartDrawer();
  }

  var sectionRootAfter = document.querySelector(
    '[data-section-type="product"][data-section-id="' + sectionId.replace(/"/g, '\\"') + '"]'
  );
  var selectedVariantForGallery = theme.parseSelectedVariantFromVariantSelects(sectionId);
  theme.applyVariantMediaGallery(selectedVariantForGallery, sectionRootAfter);
  theme.dispatchVariantImageChange(sectionRootAfter, selectedVariantForGallery);

  var firstOpt = document.querySelector('.product-variant-option');
  if (firstOpt && !firstOpt.closest('variant-selects[data-use-section-refresh="true"]')) {
    firstOpt.dispatchEvent(new Event('change'));
  }
};

/**
 * Keep ?variant= in sync after Section Rendering (slate.Variants only updates URL on native select change).
 */
theme.syncVariantUrlFromSection = function syncVariantUrlFromSection(sectionId) {
  if (!sectionId || !history.replaceState) return;
  var el = document.getElementById('ProductSelect-' + sectionId);
  if (!el) {
    var esc = sectionId.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    el = document.querySelector('[data-section-id="' + esc + '"] [name="id"]');
  }
  var vid = el && el.value;
  if (!vid) return;
  var u = new URL(window.location.href);
  u.searchParams.set('variant', String(vid));
  u.searchParams.delete('section_id');
  u.searchParams.delete('option_values');
  history.replaceState({}, '', u.toString());
};

theme.parseSelectedVariantFromVariantSelects = function parseSelectedVariantFromVariantSelects(sectionId) {
  var vs = document.getElementById('variant-selects-' + sectionId);
  if (!vs) return null;
  var script = vs.querySelector('script[data-selected-variant]');
  if (!script || !script.textContent.trim()) return null;
  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    return null;
  }
};

/**
 * Thumbnail visibility, hide-thumb, mobile product-slider, and window.selectedVariant
 * (same behavior as ProductVariantSelector.handleChange media block + theme variantImageChange).
 */
theme.applyVariantMediaGallery = function applyVariantMediaGallery(matchedVariant, sectionRoot) {
  var root = sectionRoot || document;
  var mediaGroup = sectionRoot && sectionRoot.querySelector('.product-single__media-group');

  var missing = matchedVariant === undefined || matchedVariant === null;
  if (missing) {
    if (mediaGroup) mediaGroup.classList.add('hide-thumb');
  } else if (mediaGroup) {
    mediaGroup.classList.remove('hide-thumb');
  }

  root.querySelectorAll('.thumbnails-wrapper .product-single__thumbnails-item').forEach(function (thumbnailItem) {
    var thumbImg = thumbnailItem.querySelector('.product-single__thumbnail-image');
    if (!thumbImg) return;
    var altText = thumbImg.getAttribute('alt');
    var mediaId = thumbImg.dataset.mediaId;

    var required_image = false;
    if (matchedVariant) {
      String(matchedVariant.title || '')
        .split('/')
        .forEach(function (option) {
          if (
            altText &&
            altText.includes('|') &&
            altText.split('|')[1] != '' &&
            option.trim() == altText.split('|')[1].trim()
          ) {
            required_image = true;
          }
        });
    }

    if (
      matchedVariant &&
      altText &&
      altText.includes('|') &&
      (String(altText.split('|')[1]) === '' || !required_image)
    ) {
      var fmId = matchedVariant.featured_media && matchedVariant.featured_media.id;
      if (mediaId && fmId != null && String(mediaId) !== String(fmId)) {
        thumbnailItem.classList.add('hide');
      } else {
        thumbnailItem.classList.remove('hide');
      }
    } else {
      thumbnailItem.classList.remove('hide');
    }
  });

  window.selectedVariant = matchedVariant;

  document.querySelectorAll('product-slider').forEach(function (slider) {
    try {
      slider.initProductSlider();
      slider.updatedSliderSlides();
    } catch (err) {
      /* Swiper/DOM may be absent */
    }
  });
};

theme.dispatchVariantImageChange = function dispatchVariantImageChange(sectionRoot, variant) {
  if (!sectionRoot || !variant || !variant.featured_media || !variant.featured_media.id) return;
  sectionRoot.dispatchEvent(
    new CustomEvent('variantImageChange', {
      bubbles: true,
      cancelable: true,
      detail: { variant: variant },
    })
  );
};

class ProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initProductSlider();
  }
  initProductSlider() {
    const matchedVariant = window.selectedVariant;
    const sliderThumbs = this.querySelector('.slider__thumbs .swiper-container');
    const sliderImages = this.querySelector('.slider__images .swiper-container');
    const mediaJson = window.productMediaJson;

    this.allGeneratedSlides = [];
    this.requiredSlides = [];
    if (sliderThumbs && sliderImages) {
      for (let i = 0; i < mediaJson.length; i++) {
        const media = mediaJson[i];
        if (media && media.media_type == 'image') {
          let imageEle = document.createElement('img');
          imageEle.src = media.src;
          if (media.alt === null) {
            imageEle.alt = ``;
          } else {
            imageEle.alt = `${media.alt}`;
          }

          let generatedEle = document.createElement('div');
          generatedEle.classList.add('swiper-slide');
          generatedEle.dataset.slideIndex = i;
          generatedEle.dataset.mediaId = media.id;
          generatedEle.appendChild(imageEle);
          this.allGeneratedSlides.push(generatedEle);
        }
      }

      if (this.allGeneratedSlides.length > 0 && matchedVariant) {
        this.allGeneratedSlides.forEach((slide) => {
          const img = slide.querySelector('img');
          const altText = img?.getAttribute('alt') || '';
          const mediaId = slide.dataset.mediaId;

          let required_image = false;
          if (matchedVariant) {
            matchedVariant.title.split('/').forEach((option) => {
              if (
                altText &&
                altText.includes('|') &&
                altText.split('|')[1] != '' &&
                option.trim() == altText.split('|')[1].trim()
              ) {
                required_image = true;
              }
            });
          }

          if (
            matchedVariant &&
            altText.includes('|') &&
            (`${altText.split('|')[1]}` == '' || !required_image)
          ) {
            if (mediaId == matchedVariant.featured_media.id) {
              this.requiredSlides.push(slide);
            }
          } else {
            this.requiredSlides.push(slide);
          }
          if (matchedVariant && matchedVariant.featured_media.id == slide.dataset.mediaId) {
            const mediaId = slide.dataset.mediaId;
            window.currMedia = mediaId;
          }
        });
      }

      this.swiperThumbs = new Swiper('.slider__thumbs .swiper-container', {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 6,
        freeMode: true,
        navigation: {
          nextEl: '.slider__thumbs .swiper-button-next',
          prevEl: '.slider__thumbs .swiper-button-prev',
        },
      });

      this.swiperImages = new Swiper('.slider__images .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        thumbs: {
          swiper: this.swiperThumbs,
        },
      });
    }
  }
  updatedSliderSlides() {
    this.swiperImages.removeAllSlides();
    this.swiperThumbs.removeAllSlides();
    for (let i = 0; i < this.requiredSlides.length; i++) {
      this.swiperThumbs.appendSlide(this.requiredSlides[i].outerHTML.toString());
      this.swiperImages.appendSlide(this.requiredSlides[i].outerHTML.toString());
    }

    const sliderImagesDiv = this.querySelector('.slide-mobile-custom-main');
    const originalContent = sliderImagesDiv.cloneNode(true).innerHTML;

    sliderImagesDiv.innerHTML = '';
    sliderImagesDiv.innerHTML = originalContent;

    setTimeout(() => {
      this.swiperThumbsMain = new Swiper('.slider__thumbs .swiper-container', {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 6,
        freeMode: true,
        navigation: {
          nextEl: '.slider__thumbs .swiper-button-next',
          prevEl: '.slider__thumbs .swiper-button-prev',
        },
      });

      this.swiperImagesMain = new Swiper('.slider__images .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        thumbs: {
          swiper: this.swiperThumbsMain,
        },
      });

      document.querySelectorAll('.slider__images .swiper-container .swiper-slide').forEach((i, index) => {
        i.setAttribute('data-index', index);
      });
      const index = this.querySelector(`.slider__images [data-media-id="${window.currMedia}"]`).dataset.index;
      this.swiperImagesMain.slideTo(index);
    }, 200);
  }
}
customElements.define('product-slider', ProductSlider);

class ProductVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    this.selectedOptions = [];
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.useSectionRefresh = this.dataset.useSectionRefresh === 'true';

    if (this.useSectionRefresh) {
      this.querySelectorAll('input.product-variant-option').forEach((input) => {
        input.addEventListener('change', (e) => this.handleSectionRefreshChange(e.target));
      });
      this.querySelectorAll('select.custom-option-dropdown-select').forEach((select) => {
        select.addEventListener('change', () => {
          this.syncDropdownToFieldset(select);
          const fieldset = this.findFieldsetBeforeDropdown(select);
          const checked = fieldset?.querySelector('input.product-variant-option:checked');
          this.handleSectionRefreshChange(checked);
        });
      });
      const sectionRoot = this.closest('[data-section-type="product"]');
      const selScript = this.querySelector('script[data-selected-variant]');
      if (selScript?.textContent.trim()) {
        try {
          const v = JSON.parse(selScript.textContent);
          theme.applyVariantMediaGallery(v, sectionRoot);
          theme.dispatchVariantImageChange(sectionRoot, v);
        } catch (e) {
          /* ignore */
        }
      }
      return;
    }

    const variantsScript = this.querySelector('#variants-data');
    if (!variantsScript?.textContent.trim()) return;
    try {
      this.variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      console.error('Invalid JSON in #variants-data', e);
      return;
    }

    this.querySelectorAll('input').forEach((input) => input.addEventListener('change', this.handleChange));
  }

  findFieldsetBeforeDropdown(select) {
    const wrap = select.closest('.custom-option-dropdown');
    if (!wrap) return null;
    let el = wrap.previousElementSibling;
    while (el && !el.matches?.('fieldset.product-form__input')) {
      el = el.previousElementSibling;
    }
    return el;
  }

  syncDropdownToFieldset(select) {
    const fieldset = this.findFieldsetBeforeDropdown(select);
    if (fieldset) {
      const val = select.value;
      const input = [...fieldset.querySelectorAll('input.product-variant-option')].find((inp) => inp.value === val);
      if (input) input.checked = true;
    }
  }

  collectOptionValueIds() {
    const ids = [];
    this.querySelectorAll('fieldset.product-form__input').forEach((fs) => {
      let id = null;
      let el = fs.nextElementSibling;
      while (el && !el.matches?.('fieldset.product-form__input')) {
        if (el.classList?.contains('custom-option-dropdown')) {
          const sel = el.querySelector('select.custom-option-dropdown-select');
          const opt = sel?.options?.[sel.selectedIndex];
          id = opt?.dataset?.optionValueId || opt?.getAttribute('data-option-value-id');
          break;
        }
        el = el.nextElementSibling;
      }
      if (!id) {
        const checked = fs.querySelector('input.product-variant-option:checked');
        id = checked?.dataset?.optionValueId || checked?.getAttribute('data-option-value-id');
      }
      if (id) ids.push(id);
    });
    return ids;
  }

  resolveProductPath(triggerEl) {
    if (triggerEl && triggerEl.dataset && triggerEl.dataset.productUrl) {
      const pu = String(triggerEl.dataset.productUrl).trim();
      if (pu) {
        try {
          return new URL(pu, window.location.origin).pathname;
        } catch (e) {
          return pu.startsWith('/') ? pu : window.location.pathname;
        }
      }
    }
    const dataUrl = this.dataset.productUrl;
    if (dataUrl) {
      try {
        return new URL(dataUrl, window.location.origin).pathname;
      } catch (e) {
        return dataUrl.startsWith('/') ? dataUrl : window.location.pathname;
      }
    }
    return window.location.pathname;
  }

  handleSectionRefreshChange(triggerEl) {
    const ids = this.collectOptionValueIds();
    const productPath = this.resolveProductPath(triggerEl);
    if (typeof theme.refreshProductSection === 'function') {
      theme.refreshProductSection({
        sectionId: this.dataset.sectionId,
        productPath: productPath,
        optionValueIds: ids,
      });
    }
  }

  handleChange() {
    const checkedInputs = this.querySelectorAll('.product-variant-option:checked');
    this.selectedOptions = Array.from(this.querySelectorAll('input:checked'), (input) => input.value);
    this.updateInputAvailability();
    const matchedVariant = this.getSelectedVariant(this.selectedOptions);

    const sectionRoot = this.closest('[data-section-type="product"]');
    theme.applyVariantMediaGallery(matchedVariant, sectionRoot);

    const selects = this.closest('form').querySelectorAll('.product-form__controls-group select');
    checkedInputs.forEach((item, index) => {
      const selectedOption = item.value;
      const select = selects[index];
      item.closest('.product-form__input').querySelector('[data-selected-value]').textContent = selectedOption;

      if (select) {
        select.value = selectedOption;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

  }

  updateInputAvailability() {
    this.querySelectorAll('fieldset').forEach((group, optionIndex) => {
      group.querySelectorAll('input').forEach((input) => {
        const variantOptions = [...this.selectedOptions];
        variantOptions[optionIndex] = input.value;

        const isAvailable = this.variants.some(
          (variant) => variant.available && variant.options.every((opt, i) => variantOptions[i] === opt)
        );

        input.classList.toggle('disabled', !isAvailable);
      });
    });
  }

  getSelectedVariant(selectedOptions) {
    return this.variants.find((variant) => {
      return variant.options.every((opt, index) => opt === selectedOptions[index]);
    });
  }
}
customElements.define('variant-selects', ProductVariantSelector);

document.addEventListener('DOMContentLoaded', () => {
  window.selectHandleChange();
  const firstOpt = document.querySelector('.product-variant-option');
  if (firstOpt && !firstOpt.closest('variant-selects[data-use-section-refresh="true"]')) {
    firstOpt.dispatchEvent(new Event('change'));
  }
});

window.selectHandleChange = function () {
  document.querySelectorAll('variant-selects select.custom-option-dropdown-select').forEach((select) => {
    select.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects')?.dataset.useSectionRefresh === 'true') {
        return;
      }
      const form_select = e.target
        .closest('form')
        .querySelector(`.selector-wrapper [data-select="${e.target.dataset.select}"]`);
      form_select.value = e.target.value;
      form_select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
};

function formatYotpoReviews() {
  const reviewTextEls = document.querySelectorAll('.yotpo-sr-bottom-line-text');

  reviewTextEls.forEach((el) => {
    const text = el.textContent.trim();
    const match = text.match(/^(\d+)\s+Review[s]?$/i);

    if (match) {
      const count = parseInt(match[1], 10);

      if (count === 0) {
        const buttonWrapper = el.closest('.yotpo-widget-instance');
        if (buttonWrapper) {
          buttonWrapper.style.display = 'none';
        }
        if (el.closest('.yotpo-pdp-main')) {
          el.closest('.yotpo-pdp-main').classList.add('hide');
        }
      } else {
        el.textContent = `(${count})`;
      }
    }
  });
}

const observer = new MutationObserver(() => {
  formatYotpoReviews();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

formatYotpoReviews();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.yotpo-pdp-scroll').forEach((e) => {
    e.onclick = function () {
      if (document.querySelector('#yotpo-app')) {
        document.querySelector('#yotpo-app').scrollIntoView({ behavior: 'smooth' });
      }
    };
  });
});
